// «Restaurar canal» in an archived channel's info panel (shared/API.md §41.4). Offered only when
// the server would allow it — `manage_team` on the channel's team (Mattermost 12 `restoreChannel`)
// — otherwise absent. The restore is optimistic (the worker clears delete_at first); a refusal puts
// it back and says so.
import { useEffect, useState } from 'react';
import { data } from '../../../bridge/client';
import type { ChannelRecord } from '../../../core/records';
import { t } from '../../../i18n/i18n';
import { Button, InlineStatus } from '../../kit/Kit';
import { useShell } from '../../shell/ShellContext';

export function RestoreChannelAction({ channel }: { channel: ChannelRecord }) {
  const shell = useShell();
  const [allowed, setAllowed] = useState(false);
  const [failed, setFailed] = useState(false);
  const archived = channel.deleteAt !== 0;
  useEffect(() => {
    if (!archived) return setAllowed(false);
    let live = true;
    void data.call('canRestoreChannel', channel.id).then((ok) => live && setAllowed(ok), () => undefined);
    return () => {
      live = false;
    };
  }, [channel.id, archived]);
  if (!archived || !allowed) return null;
  return (
    <div className="cp-actions nav-restore">
      {failed ? <InlineStatus kind="error" text={t('web.archived.restoreFailed')} /> : null}
      <Button
        icon="retry"
        onClick={() => {
          setFailed(false);
          void data.call('restoreChannel', channel.id).then(
            (ok) => (ok ? shell.toast(t('web.archived.restored')) : setFailed(true)),
            () => setFailed(true),
          );
        }}
      >
        {t('web.archived.restore')}
      </Button>
    </div>
  );
}
